import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__menu" }
const _hoisted_3 = { class: "layout__menu-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "hidden--flex--narrow" }
const _hoisted_8 = { id: "layout__landing" }
const _hoisted_9 = { class: "hidden--block--desktops" }
const _hoisted_10 = {
  key: 0,
  class: "layout__overlay"
}
const _hoisted_11 = { class: "layout__gadgets-top" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "layout__gadgets-menu" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Wrapper = _resolveComponent("Wrapper")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", {
        role: "header",
        class: _normalizeClass(["layout__header", [_ctx.isScroll && 'layout__header--scroll']])
      }, [
        _createVNode(_component_Wrapper, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "layout__menu-control hidden--block--desktops",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleMenu(true)), ["prevent"]))
                }, [
                  (_ctx.theme === _ctx.Themes.default && _ctx.isScroll)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/svg/menu--dark.svg`)
                      }, null, 8, _hoisted_4))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require(`@/assets/svg/menu.svg`)
                      }, null, 8, _hoisted_5))
                ]),
                _renderSlot(_ctx.$slots, "logo", {}, undefined, true)
              ]),
              _createElementVNode("ul", {
                class: _normalizeClass(["layout__links hidden--flex--gadgets", [_ctx.isScroll && 'layout__links--scroll']])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `item--${index}`
                  }, [
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: item.link
                    }, [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ], 8, _hoisted_6)), [
                      [_directive_smooth_scroll]
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "button", {}, undefined, true)
              ])
            ])
          ]),
          _: 3
        })
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "landing", {}, undefined, true)
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["layout__gadgets", [_ctx.isMenu && 'layout__gadgets--on']])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "layout__menu-control hidden--desktops",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleMenu(false)), ["prevent"]))
                }, [
                  (_ctx.theme === _ctx.Themes.default)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/svg/close.svg`)
                      }, null, 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require(`@/assets/svg/close--light.svg`)
                      }, null, 8, _hoisted_13))
                ]),
                _renderSlot(_ctx.$slots, "logo-gadgets", {}, undefined, true)
              ]),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `item--${index}`
                  }, [
                    _createElementVNode("a", {
                      href: item.link
                    }, _toDisplayString(item.text), 9, _hoisted_15)
                  ]))
                }), 128))
              ]),
              _renderSlot(_ctx.$slots, "button-gadgets", {}, undefined, true),
              _createElementVNode("img", {
                class: "layout__gadgets-logo",
                src: require(`@/assets/svg/logo_RIR--gray.svg`)
              }, null, 8, _hoisted_16)
            ], 2)), [
              [_directive_click_outside, _ctx.onClickOutside]
            ])
          ])
        ]),
        _: 3
      })
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _renderSlot(_ctx.$slots, "modals", {}, undefined, true),
      _renderSlot(_ctx.$slots, "popups", {}, undefined, true)
    ]))
  ], 64))
}